export const pages = [
  { text: '户籍人口分析', value: '/analyse/person' },
  { text: '企业指标分析', value: '/analyse/enterprise' },
  { text: '迁入迁出分析', value: '/analyse/flow' }
]

export const enterprise = {
  areaId: 148, // 地区选择
  distributionId: 149, // 企业分布
  registerId: 151, // 企业注册类型
  industryId: 152, // 三产情况
  countId: 153, // 企业总数
  typeId: 154, // 行业分类
  increaseId: 165, //净增
  loginId: 155, // 新增
  logoutId: 156, // 注销
  changeId: 157, // 变化趋势
}

export const person = {
  areaId: 160, // 地区选择
  countId: 161, // 人口总数
  distributionId: 162, // 人口分布
  ageId: 163, // 各年龄段人口
  sexId: 164, // 男女比例
}

export const flow = {
  flowId: 166, // 迁入迁出
  inYearId: 167, // 迁出年份
  moveInId: 168, // 迁出
  outYearId: 169, // 迁入年份
  moveOutId: 170, // 迁入
  cityYearId: 171, // 市内迁移年份
  flowInCityId: 172, // 市内迁移
}

// 图表配色方案三
export const colors = [
  '#3366FF', '#FF7271', '#33D499', '#FF5281', '#2A52FF',
  '#FFC779', '#11CCA6', '#FF7271', '#1AE0B8', '#1888F9',
  '#FF8547', '#33D499', '#1577FC', '#FD8B63', '#0CC1C4',
  '#FEB269', '#4C96FC',
  // 重复一遍防止数据过多不够分
  '#3366FF', '#33D499', '#FF7271', '#FF5281', '#2A52FF',
  '#FFC779', '#11CCA6', '#FF7271', '#1AE0B8', '#1888F9',
  '#FF8547', '#33D499', '#1577FC', '#FD8B63', '#0CC1C4',
  '#FEB269', '#4C96FC',
]

// 柱图默认当前年份 new Date().getFullYear()
const currentDate = new Date()
let currentYear = currentDate.getFullYear()
let defaultYearIndex = 0
const currentMonth = currentDate.getMonth() + 1
if(currentMonth <= 6) {
  currentYear = currentYear - 1
  defaultYearIndex = 1
}
// export const currentYear = 2020
// export const defaultYearIndex = 1
export {
  currentYear,
  defaultYearIndex
}

// 区县顺序
export const areaOrder = [
  { name: '安庆', order: 0, position: 'left' },
  { name: '桐城', order: 1 },
  { name: '市辖', order: 2, position: 'left' },
  { name: '怀宁', order: 3 },
  { name: '大观', order: 4, position: 'left' },
  { name: '潜山', order: 5 },
  { name: '宜秀', order: 6, position: 'left' },
  { name: '岳西', order: 7 },
  { name: '迎江', order: 8, position: 'left' },
  { name: '太湖', order: 9 },
  { name: '望江', order: 10 },
  { name: '宿松', order: 11 }
]

// 地区列表
export const areaList = ['大观区','桐城市', '宜秀区', '怀宁县', '迎江区', '潜山市', '岳西县', '太湖县', '望江县', '宿松县']

// 企业类型
export const enterpriseType = [
  '个体工商户',
  '有限责任公司',
  '有限责任公司分公司',
  '农民专业合作经济组织',
  '非公司私营企业',
  '股份有限公司分公司',
  '经营单位(非法人)',
  '集体所有制"',
  '股份有限公司',
  '全民所有制',
  '外商投资企业分支机构',
  '农民专业合作经济组织分支机构',
  '台、港、澳投资企业分支机构',
  '股份合作制',
  '内资企业集团',
  '联营',
  '股份制企业(非法人)',
  '社团法人营业',
  '内资企业法人分支机构(非法人)',
  '外国（地区）公司分支机构'
]

// 行业分类
export const businessType = [
  '批发和零售业',
  '制造业',
  '住宿和餐饮业',
  '居民服务、修理和其他服务业',
  '农、林、牧、渔业',
  '租赁和商务服务业',
  '建筑业',
  '信息传输、软件和信息技术服务业',
  '交通运输、仓储和邮政业',
  '科学研究和技术服务业',
  '房地产业',
  '文化、体育和娱乐业',
  '金融业',
  '电力、热力、燃气及水生产和供应业',
  '教育',
  '水利、环境和公共设施管理业',
  '卫生和社会工作',
  '采矿业',
  '公共管理、社会保障和社会组织'
]
